const priceFormatterWithTwoDecimals = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const priceFormatterWithoutDecimals = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

/**
 * A custom implementation of price formatter that formats a price with
 * decimals, unless it's a whole number. It doesn't fully implement
 * the Intl.NumberFormat interface. Just the format method.
 *
 * E.g. 1 is formatted as $1, while 1.5 is formatted as $1.50
 */
class PriceFormatter implements Pick<Intl.NumberFormat, 'format'> {
    format(value: number): string {
        const formatter = Number.isInteger(value)
            ? priceFormatterWithoutDecimals
            : priceFormatterWithTwoDecimals;

        return formatter.format(value);
    }
}

export const priceFormatter = new PriceFormatter();

/** A credit costs a fraction of a cent, so its price needs more precision than `priceFormatter`. */
export const creditPriceFormatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 4,
});
